import React from 'react';

const Footer = () => (
  <footer className="bg-gray-800 text-white py-8">
    <div className="container mx-auto px-6 text-center">
      <p>© 2024 Atomic Classes. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;